import { Button, IconButton, List, ListItem, Tooltip, Typography, withStyles } from '@material-ui/core';
import { createElement, FC, Fragment, useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { COLOR_BORDER_PRIMARY, COLOR_TEXT_MAIN } from '../../../constant/color';
import { context as ConfigContext } from '../../../context/config';
import EngineIcon from '../../primitive/Icons/EngineIcon';
// import HomeIcon from '../../primitive/Icons/HomeIcon';
import SalesIcon from '../../primitive/Icons/SalesIcon';
import VideoIcon from '../../primitive/Icons/VideoIcon';
import { HEADBAR_HEIGHT } from '../HeadBar';

export const LINK_MENU_WIDTH = 62;
export const LINK_MENU_OPEN_WIDTH = 182;

const ServiceContents: FC = () => {
  const config = useContext(ConfigContext);

  // 開閉したい場合は下記のコメントアウトを戻す
  const open = false;
  // const [open, setOpen] = useState(false);
  // const onClickOpen = () => {
  //   setOpen(true);
  // };
  // const onClickClose = () => {
  //   setOpen(false);
  // };

  return (
    <div
      style={{
        borderRight: `solid 1px ${COLOR_BORDER_PRIMARY}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'absolute',
        height: '100%',
        background: '#FFFFFF',
        zIndex: 1,
        width: open ? LINK_MENU_OPEN_WIDTH : LINK_MENU_WIDTH,
        transition: 'all 300ms 0s ease',
        overflow: 'hidden',
      }}
    >
      {!open ? (
        <Fragment>
          <StyledList>
            <ListItem style={{ height: HEADBAR_HEIGHT }} />
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Tooltip title={<FormattedMessage id="menu.video_application" />} placement="right">
                <IconButton
                  href={config.SALES_URL}
                  target="_blank"
                  style={{
                    borderRadius: 8,
                  }}
                >
                  <SalesIcon />
                </IconButton>
              </Tooltip>
            </ListItem>
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Tooltip title={<FormattedMessage id="menu.web_optimization" />} placement="right">
                <IconButton
                  href={`${config.CLOUD_BASE_URL}engine/`}
                  target="_blank"
                  style={{
                    borderRadius: 8,
                  }}
                >
                  <EngineIcon />
                </IconButton>
              </Tooltip>
            </ListItem>
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Tooltip title={<FormattedMessage id="menu.video_production" />} placement="right">
                <IconButton
                  href={config.AD_DASHBOARD_URL}
                  target="_blank"
                  style={{
                    borderRadius: 8,
                  }}
                >
                  <VideoIcon />
                </IconButton>
              </Tooltip>
            </ListItem>
          </StyledList>
          {/* 開閉したい場合は下記のコメントアウトを戻す */}
          {/* <StyledList>
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Tooltip title="アカウント設定" placement="right">
                <IconButton
                  // href={config.ID_DASHBOARD_URL}
                  // target="_blank"
                  style={{
                    borderRadius: 8,
                    backgroundColor: COLOR_SIDEMENU_CONTENT_SELECTED,
                  }}
                >
                  <AccountConsoleIcon />
                </IconButton>
              </Tooltip>
            </ListItem>
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Tooltip title="メニューを開く" placement="right">
                <IconButton
                  style={{
                    height: 48,
                    width: 48,
                    borderRadius: 8,
                  }}
                  onClick={onClickOpen}
                >
                  <SidebarOpenIcon />
                </IconButton>
              </Tooltip>
            </ListItem>
          </StyledList> */}
        </Fragment>
      ) : (
        <Fragment>
          <StyledOpenList>
            <ListItem style={{ height: HEADBAR_HEIGHT }} />
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Button
                href={config.SALES_URL}
                target="_blank"
                style={{
                  borderRadius: 8,
                  width: 150,
                  height: 40,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  padding: '0px 4px',
                  // paddingLeft: 16,
                }}
              >
                <SalesIcon />
                <Typography style={{ fontSize: 14, fontWeight: 700, color: COLOR_TEXT_MAIN, marginLeft: 12 }}>
                  <FormattedMessage id="menu.video_application" />
                </Typography>
              </Button>
            </ListItem>
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Button
                href={config.SITE_DASHBOARD_URL}
                target="_blank"
                style={{
                  borderRadius: 8,
                  width: 150,
                  height: 40,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  padding: '0px 4px',
                  // paddingLeft: 16,
                }}
              >
                <EngineIcon />
                <Typography style={{ fontSize: 14, fontWeight: 700, color: COLOR_TEXT_MAIN, marginLeft: 12 }}>
                  <FormattedMessage id="menu.web_optimization" />
                </Typography>
              </Button>
            </ListItem>
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Button
                href={config.AD_DASHBOARD_URL}
                target="_blank"
                style={{
                  borderRadius: 8,
                  width: 150,
                  height: 40,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  padding: '0px 4px',
                  // paddingLeft: 16,
                }}
              >
                <VideoIcon />
                <Typography style={{ fontSize: 14, fontWeight: 700, color: COLOR_TEXT_MAIN, marginLeft: 12 }}>
                  <FormattedMessage id="menu.video_production" />
                </Typography>
              </Button>
            </ListItem>
          </StyledOpenList>
          {/* 開閉したい場合は下記のコメントアウトを戻す */}
          {/* <StyledOpenList>
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Button
                style={{
                  borderRadius: 8,
                  width: 150,
                  height: 40,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  padding: '0px 4px',
                  backgroundColor: COLOR_SIDEMENU_CONTENT_SELECTED,
                }}
              >
                <AccountConsoleIcon />
                <Typography style={{ fontSize: 14, fontWeight: 700, color: COLOR_TEXT_MAIN, marginLeft: 8 }}>
                  アカウント設定
                </Typography>
              </Button>
            </ListItem>
            <ListItem
              style={{
                height: 48,
                justifyContent: 'center',
                margin: '16px 0px',
              }}
            >
              <Button
                style={{
                  borderRadius: 8,
                  width: 150,
                  height: 40,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  padding: '0px 4px',
                }}
                onClick={onClickClose}
              >
                <SidebarCloseIcon />
                <Typography style={{ fontSize: 14, fontWeight: 700, color: COLOR_TEXT_MAIN, marginLeft: 8 }}>
                  メニューを閉じる
                </Typography>
              </Button>
            </ListItem>
          </StyledOpenList> */}
        </Fragment>
      )}
    </div>
  );
};

const StyledList = withStyles({
  root: {
    width: LINK_MENU_WIDTH,
    padding: 0,
  },
})(List);

const StyledOpenList = withStyles({
  root: {
    width: LINK_MENU_OPEN_WIDTH,
    padding: 0,
  },
})(List);

export default ServiceContents;
